import React, { useEffect } from "react";
import "../Css/InnovationPongAI.css";
import pongaiLogo from "../Assets/PongAILogo.jpeg";

const InnovationPongAI = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Innovation & PongAI | SportsForEquity";

    let metaDescription = document.querySelector('meta[name="description"]');
    let createdMeta = false;
    const prevDescription = metaDescription
      ? metaDescription.getAttribute("content")
      : null;

    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
      createdMeta = true;
    }
    metaDescription.setAttribute(
      "content",
      "PongAICoach is SportsForEquity's human-centered table tennis analysis system that turns match video into movement and technique insights using body-pose analysis."
    );

    return () => {
      document.title = prevTitle;
      if (createdMeta) {
        metaDescription.remove();
      } else if (prevDescription !== null) {
        metaDescription.setAttribute("content", prevDescription);
      }
    };
  }, []);

  return (
    <div className="ip-page">

      {/* Hero */}
      <div className="ip-hero">
        <video
          className="ip-hero-video"
          src="/hero/rally.mp4"
          poster="/hero/rally-poster.jpg"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
        <div className="ip-hero-overlay" />
        <div className="ip-hero-content">
          <h1 className="ip-hero-title">
            Making AI-powered table tennis coaching accessible for skill
            development and neuro-wellness.
          </h1>
        </div>
      </div>

      {/* Below-hero content */}
      <div className="ip-body-wrap">
        {/* About */}
        <div className="ip-section">
          <h2 className="ip-section-heading">About PongAICoach</h2>
          <p className="ip-body">
            PongAI Coach is built on the award-recognized KINESIS research, recognized by IEEE.
            Using AI-powered body-pose analysis, PongAI Coach transforms table
            tennis videos into movement and technique insights, supporting
            SportsForEquity’s mission to make personalized coaching more
            accessible and explore future applications in Parkinson’s
            neuro-wellness.
          </p>
        </div>

        {/* Logo */}
        <div className="ip-logo-section">
          <img
            src={pongaiLogo}
            alt="PongAI — Table Tennis, Understood Through Movement"
            className="ip-logo"
          />
        </div>

        {/* CTA */}
        <div className="ip-section ip-cta-section">
          <a
            href="https://pongaicoach.live/"
            target="_blank"
            rel="noopener noreferrer"
            className="ip-cta-btn"
          >
            Explore PongAICoach →
          </a>
        </div>
      </div>

    </div>
  );
};

export default InnovationPongAI;